import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BatchDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.setBatchReferenceLine
>;

export const setBatchReferenceLine = async ({ id }: { id: string }): Promise<BatchDto> => {
  const response = await api.quoteRequestLines.setBatchReferenceLine.mutation({
    params: { id },
    body: {},
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to set the batch reference line", response.status, response.body);
};
